import { render, staticRenderFns } from "./SelectModalContentsCategoryItem.vue?vue&type=template&id=2b933a97"
import script from "./SelectModalContentsCategoryItem.vue?vue&type=script&lang=js"
export * from "./SelectModalContentsCategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports